import { Box, Button, Center, Divider, Flex, Image, Progress, SimpleGrid } from '@chakra-ui/react';
import { Form, Formik, FormikConfig, FormikHelpers, FormikValues } from 'formik';
import React, { useEffect, useState } from 'react';
import PathMatchLogo from '../../assets/icons/PathMatchLogo.png';
import FormNavigation from './FormNavigation';

interface Props extends FormikConfig<FormikValues> {
    children: React.ReactNode;
    isButton?: boolean;
    enableReinitialize?: boolean;
}

const MultiStepForm = ({ children, initialValues, onSubmit, enableReinitialize }: Props) => {
    const [stepNumber, setStepNumber] = useState(0);
    const steps = React.Children.toArray(children) as React.ReactElement[];

    const [snapshot, setSnapshot] = useState(initialValues);
    useEffect(()=> {
        setSnapshot(initialValues);
    }, [initialValues])
    const step = steps[stepNumber];
    const totalSteps = steps.length;
    const isLastStep = stepNumber === totalSteps - 1;
    const progressBarValue = (stepNumber + 1) * (100 / totalSteps);

    const next = (values: FormikValues) => {
        setSnapshot(values);
        setStepNumber(stepNumber + 1);
    };
    
    const previous = (values: FormikValues) => {
        setSnapshot(values);
        setStepNumber(stepNumber - 1);
    };

    const handleSubmit = async (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
        if (step.props.onSubmit) {
            await step.props.onSubmit(values);
        }

        if (isLastStep) {
            return onSubmit(values, actions);
        } else {
            actions.setTouched({});
            next(values);
        }
    };

    return (
        <div>
            <SimpleGrid columns={3} h="80px">
                <Flex mt="auto" mb="auto" ml="8">
                    {stepNumber > 0 && (
                        <Button
                            onClick={() => previous(snapshot)}
                            justifyContent="space-between"
                            borderRadius="100px"
                            bg="white"
                            border="1px solid #EBEBEC"
                        >
                            {' '}
                            ← Back
                        </Button>
                    )}
                </Flex>
                <Center>
                    <a href="pathmatch.com">
                        <Image
                            src={PathMatchLogo}
                            alt="PathMatch Logo"
                            width="150px"
                            height="auto"
                        />
                    </a>
                </Center>
                <Box></Box>
            </SimpleGrid>
            <Divider mb="5" bg="black" />
            <Center>
                <Center h="8px" w="290px" mb="10">
                    <Progress
                        borderRadius="8px"
                        bg="#F5F5F6"
                        h="8px"
                        w="100%"
                        value={progressBarValue}
                        sx={{
                            '& > div': {
                                background:
                                    'linear-gradient(90deg, rgba(69,72,231,243) 10%, rgba(66,153,225,1) 90%)'
                            }
                        }}
                    />
                </Center>
            </Center>
            <Formik
                initialValues={snapshot}
                onSubmit={handleSubmit}
                enableReinitialize={enableReinitialize}
                validationSchema={step.props.validationSchema}
            >
                {(formik: any) => (
                    <Form>
                        {React.cloneElement(step, {values: formik.values, onSubmit: step.props.onSumbit})}

                        {!step.props.hasOwnNavigation && (
                            <FormNavigation
                                isLastStep={isLastStep}
                                hasPrevious={stepNumber > 0}
                                onBackClick={() => previous(formik.values)}
                                isFilled={step.props.isFilled}
                                buttonWidth={step.props.buttonWidth}
                                hasSkipButton={step.props.hasSkipButton}
                                skipbuttonText={step.props.skipbuttonText}
                            />
                        )}
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default MultiStepForm;

export const FormStep = ({ stepName = '', children, isRadio }: any) => children;
